import type { Booking } from "@/types/Booking";
import { TriangleAlert } from "lucide-react";

type SystemProps = {
  booking?: Booking;
};

const System = ({ booking }: SystemProps) => {
  const renderSystemBooking = () => {
    return (
      <span title="System booking" aria-label="System booking">
        <TriangleAlert className="w-4" />
      </span>
    );
  };

  return <div className="uppercase">{booking?.memberId === "system" ? renderSystemBooking() : null}</div>;
};

export default System;
